
import PropTypes from "prop-types"
import React from "react"
import { Link, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import {HandleImages} from "../components/functions"

import OnVisible from 'react-on-visible';
import "../css/overlay-blurb.css"

const style = {
   
  }
  var height
  var position



class OverlayBlurb extends React.Component{  




    constructor(props) {
        
        super(props);
        this.myRef = React.createRef();
        this.handleScroll = this.handleScroll.bind(this)
      }

      componentDidMount() {
  
      window.addEventListener('scroll', this.handleScroll);
      // console.log(this.myRef.current.getBoundingClientRect().left + window.scrollX, this.myRef.current.getBoundingClientRect().top + window.scrollY);

      }

      componentWillUnmount(){
        window.removeEventListener('scroll', this.handleScroll);
      }
handleScroll(event){
    height = window.innerHeight
    || document.documentElement.clientHeight
    || document.body.clientHeight;
    position=  (((this.myRef.current.getBoundingClientRect().bottom - this.myRef.current.getBoundingClientRect().top )/ 2) + this.myRef.current.getBoundingClientRect().top) / height ;
// console.log(this.myRef.current.childNodes[0].childNodes[0],position )
this.myRef.current.childNodes[0].childNodes[0].style.transform = "translateX(2em) translateY("+position * 30+"%)";
}


  render() {
  

   
return(
  <OnVisible className="overlay-blurb-wrapper">
   <div className="overlay-blurb" ref={this.myRef}>
<PreComp/>
</div>
   </OnVisible>)
  }
}
 
function PreComp ( ){




 
  return  < >
<div>
<div   ><HandleImages name={'womanScreen'}/> </div>
<HandleImages name={'manWomanComputer'}/>
</div>
<div className="blurb-wrap">
    <div>
  <p><h2>Circadence is dedicated to cyber training and education</h2></p>  
   <p> <h4>We help new and seasoned cyber security professionals embrace a new way to train and develop cyber security skills and competencies. </h4></p>
    <p><strong>We gamify cyber learning</strong> so IT and infosec professionals can enjoy cyber training.  </p>
    <p><strong>We make learning cyber hands-on </strong>so skills acquisition and maturation is relevant to specific readiness needs.   </p>
    <p><strong>We believe in immersive learning </strong>so institutions, organizations and individuals can make persistent cyber training a habitual part of their readiness goals.</p></div>
</div></>
 
}

export default OverlayBlurb


